<template>
  <v-menu
    style="z-index: 100"
    ref="menu"
    v-model="showTimePickMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="time"
        :label="label"
        :prepend-icon="prependIcon"
        :hint="hint"
        :disabled="disabled"
        :persistent-hint="hintIsPersistend"
        :readonly="textFieldIsReadonly"
        v-on="on"
        :rules="commonRules"></v-text-field>
    </template>

    <v-time-picker
      v-if="showTimePickMenu"
      scrollable
      v-model="time"
      :allowed-minutes="allowedMinutes"
      :min="min"
      :max="max"
      format="24hr"
      :disabled="disabled"
      full-width
      @click:minute="$refs.menu.save(time)" />
  </v-menu>
</template>

<script>
// mixins
import Helpers from '@/mixins/helpers.js';
import Validation from '@/mixins/validationRules.js';

export default {
  name: 'TimePicker',

  emits: ['input'],

  mixins: [Helpers, Validation],

  props: {
    /**
     * passed: will be set as default value
     *
     * not passed: default value is ""
     */
    value: String,
    /** the label of the textbox */
    label: String,
    /** the hint of the textbox */
    hint: String,
    /** icon which is placed in front of the textbox  */
    prependIcon: String,
    /** whether the hint should always be displayed */
    hintIsPersistend: Boolean,
    /** makes the textbox readonly */
    textFieldIsReadonly: Boolean,
    min: String,
    max: String,
    disabled: Boolean,
    step: Number,
  },

  data: () => ({
    // whether to show the time selection
    showTimePickMenu: false,
    currentTime: null,
    allowedMinutes: (minutes) => [0, 15, 30, 45].includes(minutes),
  }),

  methods: {
    timePickerStartHours: (hour) => (this.min && this.max ? hour >= this.min || hour <= this.max : true),

    saveTime(newTime) {
      this.$emit('input', newTime);
    },

    isTimeLessThan(timeToCompare, minTime) {
      const baseDate = '2000-01-01';

      const timeComapre = new Date(`${baseDate}T${timeToCompare}:00`);
      const timeMin = new Date(`${baseDate}T${minTime}:00`);

      return timeComapre < timeMin;
    },
    isTimeGreaterThan(timeToCompare, maxTime) {
      const baseDate = '2000-01-01';

      const timeComapre = new Date(`${baseDate}T${timeToCompare}:00`);
      const timeMax = new Date(`${baseDate}T${maxTime}:00`);

      return timeComapre > timeMax;
    },
  },

  computed: {
    showTimePicker: {
      set(show, newTime = '') {
        this.showTimePicker = show;
        if (!this.IsNoWs(newTime)) this.saveTime();
      },
      get() {
        return this.showTimePicker;
      },
    },
    time: {
      set(newTime) {
        console.log(newTime);
        if (this.currentTime != newTime) {
          if (this.isTimeLessThan(newTime, this.min)) {
            newTime = this.min;
          } else if (this.isTimeGreaterThan(newTime, this.max)) {
            newTime = this.max;
          }

          this.saveTime(newTime);
        }
        this.currentTime = newTime;
      },
      get() {
        return this.currentTime;
      },
    },
  },

  watch: {
    value(newVal) {
      if (newVal != this.currentTime) this.currentTime = newVal;
    },
  },
};
</script>
